import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-745d6d92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { "aria-label": "Breadcrumb" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, "Home")
], -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "img-wrapper" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "text-content" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "heading" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("by ")
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "date" }
const _hoisted_17 = { class: "mt-2 truncate-text" }
const _hoisted_18 = {
  key: 0,
  class: "pagination"
}
const _hoisted_19 = { class: "sidebar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_front_sidebar = _resolveComponent("front-sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LeftSideBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBreadcrumbs(), (bread, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_va_icon, { name: "chevron_right" }),
              _createElementVNode("a", {
                href: bread.path
              }, _toDisplayString(bread.name), 9, _hoisted_6)
            ]))
          }), 128))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showPostPageWise(), (post, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "post-list",
          key: post.id || index,
          onClick: ($event: any) => (_ctx.viewPostById(post))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: _ctx.extractImgUrl(post),
              alt: post?.indlaeg_slug
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "category-badge",
              onClick: (event) => _ctx.goToCategories(post?.indlaeg_kategori_id?.indlaeg_kategori_titel, event)
            }, _toDisplayString(post.indlaeg_kategori_id?.indlaeg_kategori_titel), 9, _hoisted_11),
            _createElementVNode("p", _hoisted_12, _toDisplayString(post.indlaeg_versionerings_id?.[0]?.indlaeg_versionering_titel), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, [
                _hoisted_14,
                _createElementVNode("span", {
                  onClick: (event) => _ctx.goToAuthorPosts(post.indlaeg_forfatter?.firstname + '-' + post.indlaeg_forfatter?.lastname, event),
                  class: "red-hover"
                }, _toDisplayString(post.indlaeg_forfatter?.firstname + ' ' + post.indlaeg_forfatter?.lastname), 9, _hoisted_15)
              ]),
              _createElementVNode("span", _hoisted_16, [
                _createVNode(_component_va_icon, {
                  size: "11px",
                  name: "schedule"
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(post?.updatedAt)), 1),
                _createVNode(_component_va_icon, {
                  size: "11px",
                  name: "visibility"
                }),
                _createElementVNode("span", null, _toDisplayString(post?.indlaeg_visninger || 0), 1)
              ])
            ]),
            _createElementVNode("p", _hoisted_17, _toDisplayString(post?.indlaeg_slug), 1)
          ])
        ], 8, _hoisted_7))
      }), 128)),
      (_ctx.getPosts().length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("span", {
              class: "box",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentPage(_ctx.getCurrentPage() - 1)))
            }, [
              _createVNode(_component_va_icon, { name: "chevron_left" })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationView(), (pageNo, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: _normalizeClass(["box", { active: pageNo === _ctx.getCurrentPage() }]),
                onClick: _cache[1] || (_cache[1] = (event)=> _ctx.setCurrentPage(event.target.innerText))
              }, _toDisplayString(pageNo), 3))
            }), 128)),
            _createElementVNode("span", {
              class: "box",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentPage(_ctx.getCurrentPage() + 1)))
            }, [
              _createVNode(_component_va_icon, { name: "chevron_right" })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_front_sidebar)
    ])
  ]))
}